// client/src/components/common/Header.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { FaUser } from 'react-icons/fa'; // Keep only the necessary icon
import { RxDashboard } from "react-icons/rx";
import './Header.css';
import MobileNavbar from './MobileNavbar.js'; // Import MobileNavbar
import useWindowSize from '../../hooks/useWindowSize.js';// Import the hook
import { useAuth } from '../../context/AuthContext'; // Import useAuth

function Header() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const windowSize = useWindowSize(); // Use the hook
  const { user } = useAuth(); // Get isLoggedIn state

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const isMobile = windowSize.width <= 768;
  const isRTL = i18n.language === 'ar';

  return (
    <>
        {isMobile ? (
            <MobileNavbar menuOpen={menuOpen} toggleMenu={toggleMenu} />
            ) : (
            <header className="header">
              <div className={`container ${isRTL ? 'rtl' : ''}`}>
                <div className="logo">
                    <Link to="/">{t('header.beinSmart')}</Link>
                </div>
                <nav className="navbar">
                    <ul>
                    <li><NavLink to="/" end >{t('header.home')}</NavLink></li>
                    <li><NavLink to="/services" >{t('header.services')}</NavLink></li>
                    <li><NavLink to="/products" >{t('header.products')}</NavLink></li>
                    <li><NavLink to="/blog" >{t('header.blog')}</NavLink></li>
                    <li><NavLink to="/about" >{t('header.aboutUs')}</NavLink></li>
                    <li><NavLink to="/contact" >{t('header.contact')}</NavLink></li>
                    <li>
                      <Link to={user ? "/dashboard" : "/login"} className="login-link">
                        {user ? <RxDashboard /> : <FaUser />} 
                      </Link>
                    </li> {/* Login Icon */}
                    </ul>
                </nav>
              </div>
            </header>
        )}
    </>
  );
}

export default Header;